import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['input']

  empty() {
    if (this.hasInputTarget) this.inputTarget.value = ''
  }
}
